import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import SearchPage from "@/pages/SearchPage";
import ListingDetailPage from "@/pages/ListingDetailPage";
import BookingConfirmation from "@/pages/BookingConfirmation";
import CustomerDashboard from "@/pages/CustomerDashboard";
import HostDashboard from "@/pages/HostDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ApiDocsPage from "@/pages/ApiDocsPage";
import { BlogListPage, BlogDetailPage } from "@/pages/BlogPage";
import "@/App.css";
import "@/admin-theme.css";

function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-[#0B061A]"><div className="animate-spin w-8 h-8 border-2 border-[#00F0FF] border-t-transparent rounded-full" /></div>;
  if (!user) return <Navigate to="/auth" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" />;
  return children;
}

const IS_ADMIN_BUILD = process.env.REACT_APP_MODE === "admin";

function App() {
  useEffect(() => {
    if (IS_ADMIN_BUILD) {
      // Honour saved theme preference (default = dark for admin)
      const saved = localStorage.getItem("ss_admin_theme");
      const mode = saved === "light" ? "light" : "admin";
      document.documentElement.setAttribute("data-mode", mode);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-[#0B061A]">
          <Navbar />
          <Routes>
            <Route path="/" element={IS_ADMIN_BUILD ? <Navigate to="/auth" replace /> : <LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            {!IS_ADMIN_BUILD && <Route path="/search" element={<SearchPage />} />}
            {!IS_ADMIN_BUILD && <Route path="/listing/:id" element={<ListingDetailPage />} />}
            {!IS_ADMIN_BUILD && <Route path="/booking-confirmation/:id" element={<ProtectedRoute><BookingConfirmation /></ProtectedRoute>} />}
            {!IS_ADMIN_BUILD && <Route path="/dashboard" element={<ProtectedRoute roles={["customer"]}><CustomerDashboard /></ProtectedRoute>} />}
            {!IS_ADMIN_BUILD && <Route path="/host" element={<ProtectedRoute roles={["host"]}><HostDashboard /></ProtectedRoute>} />}
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
            {!IS_ADMIN_BUILD && <Route path="/developers" element={<ApiDocsPage />} />}
            {!IS_ADMIN_BUILD && <Route path="/blog" element={<BlogListPage />} />}
            {!IS_ADMIN_BUILD && <Route path="/blog/:slug" element={<BlogDetailPage />} />}
            {IS_ADMIN_BUILD && <Route path="*" element={<Navigate to="/auth" replace />} />}
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
